import api from 'src/Utils/api';
export var createAlert = function () { return api.post("/alerts"); };
